/**
 * Created with IntelliJ IDEA.
 * User: vanessat
 * Date: 11/23/14
 * Time: 3:29 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {

    var App = window.App || {};

    var lpAgent = require('web-agent-assets-js/lpAgent');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    lpTag.AgentList = function () {

        this.applicationType = "AgentList";
        var POLLING_TIME_IN_SEC = 10;

        var resourceDomainUrl;
        var method = 'POST';
        var getSingleAdditionalUrl = "?timestamp={timestamp}&v=1&data=true";
        var agentListApiResource;

        function initService() {
            if (!agentListApiResource) {
                resourceDomainUrl = lpAgent.agent.getURI('available-agents-query', {type: 'agent'});
                if (!resourceDomainUrl || resourceDomainUrl === '') {
                    resourceDomainUrl = lpAgent.agent.getURI('available-agents', {type: 'agent'});
                    method = 'GET';
                }
                agentListApiResource = BaseApiService.createInstance({domainUrl: resourceDomainUrl, postmessagePath: "/postmessage", serviceName: this.applicationType});
            }
        }

        this.searchAgents = function (reqObj) {
            initService();
            var timestamp = new Date().getTime();

            reqObj.method = method;
            if (method === 'POST') {
                var data = reqObj.data;
                reqObj.data = {
                    availableAgentsQuery: data
                };
            }
            reqObj.additionalUrl = getSingleAdditionalUrl.replace('{timestamp}', timestamp + "");
            reqObj.pollingTimeout = reqObj.pollingTimeout || (1000 * POLLING_TIME_IN_SEC);
            agentListApiResource.startPolling(reqObj);
        };

        this.stopPolling = function () {
            if (agentListApiResource) {
                agentListApiResource.stopPolling();
            }
        };
    };

    return lpTag.AgentList;

});
